export default __webpack_public_path__ + "f9b07c6c6da89acb1be0d17f77d5adb5.png";